import { cn } from "@/lib/utils";
import { ProgressInfoTooltip } from "./ProgressInfoTooltip";

export const ProgressMetricCard = ({
  icon: Icon,
  label,
  value = null,
  unit = null,
  subtitle = null,
  trend = null,
  tooltip = null,
  status = null,
  unavailable = false,
  accent = null,
  soft = null,
  prominent = false,
  className = "",
  testId,
}) => {
  const hasValue = value != null || typeof value === "number" || typeof value === "boolean";
  const isUnavailable = unavailable || (!hasValue && !status);

  const renderValue = () => {
    if (isUnavailable) {
      return (
        <span
          className="text-sm text-dark-text-muted"
          data-testid={testId ? `${testId}-unavailable` : undefined}
        >
          Unavailable
        </span>
      );
    }

    if (typeof value === "number" && Number.isFinite(value)) {
      const formatted = Number.isInteger(value) ? String(value) : value.toFixed(2);
      return (
        <>
          {formatted}
          {unit != null ? <span className="metric-unit">{unit}</span> : null}
        </>
      );
    }

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    return value;
  };

  return (
    <div
      className={cn("metric-card", prominent && "shadow-app-sm", className)}
      data-testid={testId}
      style={accent ? { borderLeft: `3px solid ${accent}` } : undefined}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="card-label">{label}</div>
        <div className="flex items-center gap-1.5 shrink-0">
          {tooltip ? (
            <ProgressInfoTooltip
              label={tooltip.label || label}
              content={tooltip.content}
              testId={tooltip.testId}
            />
          ) : null}
          {Icon ? (
            <div
              className="icon-frame w-7 h-7"
              style={
                accent
                  ? { color: accent, background: soft || undefined, borderColor: `${accent}55` }
                  : undefined
              }
            >
              <Icon className="w-3.5 h-3.5" strokeWidth={1.75} aria-hidden="true" />
            </div>
          ) : null}
        </div>
      </div>
      {status ? (
        <div className="mt-3">{status}</div>
      ) : (
        <div className={cn("metric-value mt-2", prominent && "text-2xl sm:text-3xl")}>
          {renderValue()}
        </div>
      )}
      {trend ? <div className="meta-text mt-1">{trend}</div> : null}
      {subtitle ? <div className="meta-text mt-1">{subtitle}</div> : null}
    </div>
  );
};
